import clsx from "classnames";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";
// import Marquee, { Motion, randomIntFromInterval } from "react-marquee-slider";
import FooterWave2Icon from "@/public/site-assets/svg/footer-wave-2.svg";
import Marquee from "react-fast-marquee";

export const ImageCarousel = ({
  className,
  post,
  content,
  heading,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section
        className={clsx(
          className,
          styles.root,
          showTopWave ? "pt-0" : "pt-5",
          showWave ? "pb-0" : "pb-5",
        )}
      >
        <Container>
          <div className="wrapper">
            {heading && <h2 className={`h3`}>{heading}</h2>}
            {content && <div className={`content`} dangerouslySetInnerHTML={{ __html: content }} />}
          </div>
        </Container>
        <div className={`${content && "mt-5"}`}>
          <Marquee speed={12}>
            {post?.map((post, index) => (
              <div key={index} className="column">
                <img
                  src={post?.image?.url || "/public/images/placeholders/img-placeholder.jpg"}
                  alt={`${post?.image?.alt}`}
                />
              </div>
            ))}
          </Marquee>
        </div>
      </section>
      {showWave && (
        <div
          className={clsx(
            "footer",
            waveDirection === "down" && "rotate",
            waveColor,
            waveBackground,
          )}
          style={{ marginTop: "-1px" }}
        >
          <FooterWave2Icon />
        </div>
      )}
    </>
  );
};

export default ImageCarousel;
